<template>

    <a-card title="" :bordered="false">
        <div class="main">
            <div class="actions">
                <router-link to="/inventory"
                    style="font-size:14px;text-decoration:none;line-height:30px;color:#111827;display:flex">
                    <p style="font-size: 10px;">
                        <a-icon type="arrow-left" />
                    </p>
                    <p style="margin-left: 10px; font-size: 15px;">Go Back To Products</p>

                </router-link>

                <a-button @click="showEditProductPage"
                    style="width:159px; height:38px;border-raduis:5px; background: #ffffff">
                    Edit Products
                </a-button>
            </div>

            <!-- <div style="text-align:start;padding-top:20.7px;">
           <h3>{{items.brandName}} Product</h3>
       </div> -->
            <div style="padding-top:30px">
                <!-- <a-row>
               <a-col style="background:#fff" :span="10" :offset="1">
                   <div style="display:flex;justify-content: start; flex-direction: column;padding: 40px;margin-bottom:10px">
                        <a-collapse :bordered="false" v-model="activeKey" :expand-icon-position="expandIconPosition">
                            <a-collapse-panel key="1" header="Product Category Information">
                                <a-row type="flex" justify="space-between" align="middle">
                                    <a-col>Product Group:</a-col>
                                    <a-col style="color:green">{{items.groupName}}</a-col>
                                </a-row>
                                <a-row class="mt-4" type="flex" justify="space-between" align="middle">
                                    <a-col>Product Category:</a-col>
                                    <a-col style="color:green">{{items.categoryName}}</a-col>
                                </a-row>
                            </a-collapse-panel>
                            <a-collapse-panel key="2" header="Product Details">
                                <a-row type="flex" justify="space-between" align="middle">
                                    <a-col>Supplier:</a-col>
                                    <a-col style="color:green">{{displayProductDetails.supplierName}}</a-col>
                                </a-row>
                                <a-row class="mt-4" type="flex" justify="space-between" align="middle">
                                    <a-col>Manufacturer:</a-col>
                                    <a-col style="color:green">{{displayProductDetails.manufacturerName}}</a-col>
                                </a-row>
                                <a-row class="mt-4" type="flex" justify="space-between" align="middle">
                                    <a-col>Generic Name:</a-col>
                                    <a-col style="color:green">{{displayProductDetails.genericName}}</a-col>
                                </a-row>
                                <a-row class="mt-4" type="flex" justify="space-between" align="middle">
                                    <a-col>Cost Price:</a-col>
                                    <a-col style="color:green">Ksh {{ displayProductDetails.purchasePrice  !== undefined ? displayProductDetails.purchasePrice.toLocaleString(undefined,{minimumFractionDigits: 2}) : "N/A" }}</a-col>
                                </a-row>
                                <a-row class="mt-4" type="flex" justify="space-between" align="middle">
                                    <a-col>Selling Price:</a-col>
                                    <a-col style="color:green">Ksh {{ displayProductDetails.sellingPrice !== undefined ? displayProductDetails.sellingPrice.toLocaleString(undefined,{minimumFractionDigits: 2}) : "N/A" }}</a-col>
                                </a-row>
                                <a-row class="mt-4" type="flex" justify="space-between" align="middle">
                                    <a-col>Margin:</a-col>
                                    <a-col style="color:green">{{ displayProductDetails.margin !== undefined ? displayProductDetails.margin.toFixed(2) : "N/A" }}%</a-col>
                                </a-row>
                            </a-collapse-panel>
                            <a-collapse-panel key="3" header="Inventory Details" >
                                <a-row class="mt-2">
                                    <a-col>Will you like to Prestock this product at our Fufillment Center?</a-col>
                                    <a-col style="color:green;padding-top:10px">{{ productInventoryDetails.isPrestocked === true ? "Yes": "No" }}</a-col>
                                </a-row>
                                <a-row class="mt-4">
                                    <a-col>How many units will you like to send?</a-col>
                                    <a-col style="color:green;padding-top:10px"> {{ productInventoryDetails.prestockQuantity ? productInventoryDetails.prestockQuantity : "N/A" }}</a-col>
                                </a-row>
                                <a-row class="mt-4">
                                    <a-col>How often do you want to replenish the available stock at Fulfillment Center?</a-col>
                                    <a-col style="color:green;padding-top:10px">{{ displayFrequency }}</a-col>
                                </a-row>
                                <a-row class="mt-4">
                                    <a-col>Will you like to take Pre-Order for this product?</a-col>
                                    <a-col style="color:green;padding-top:10px">{{ productInventoryDetails.isPreordered === true ? "Yes": "No" }}</a-col>
                                </a-row>
                                <a-row class="mt-4">
                                    <a-col>What maximum unit should we to take preorders for this product?</a-col>
                                    <a-col style="color:green;padding-top:10px">{{ productInventoryDetails.maximumPreorderedQuantity ? productInventoryDetails.maximumPreorderedQuantity : "N/A" }}</a-col>
                                </a-row>
                                <a-row class="mt-4">
                                    <a-col>When a pre-order is taken for this product, how soon can you ship?</a-col>
                                    <a-col style="color:green;padding-top:10px">{{ productInventoryDetails.fulfilmentLatency ? productInventoryDetails.fulfilmentLatency : "N/A" }}</a-col>
                                </a-row>
                            </a-collapse-panel>
                        </a-collapse>
                   </div>
               </a-col>
               <a-col style="background:#fff;margin-bottom: 50px;" :span="10" :offset="1">
                   <p style="display:flex;justify-content: center;margin-top:20px;">Product Image</p>
                   <div>
                       <div v-if="showImage">
                           <a-carousel autoplay>
                                        <div v-for="image in images" :key="image" style="display:flex;justify-content: center;width:100%">
                                            <img class="img_size" :src="image"/>
                                        </div>
                                
                            </a-carousel>
                       </div>

                       <div v-else class="text-center">
                           No image for this product
                       </div>
                       
                   </div>
               </a-col>
           </a-row> -->
                <!-- <div style="display: flex; justify-content: start;">
            <a-col :span="5" :offset="0">
                 <div style="display:flex;justify-content: center;">
                    <img class="img_size" src="../../assets/img/celic.png"/>
                </div>
            </a-col>
            <a-col :span="10" :offset="0">
                <div style="font-size: 15px; margin-top: 10px; font-weight: 900; display: flex; flex-direction: column; justify-content: center; ">
                    Advanced Egg Formula 1kg
                <br>
                Batch Number
                </div>
            </a-col>
        </div>
           <div style="width: 100%; margin-top: 30px; display: flex; justify-content: start;">
                <a-tabs type="card" v-model="activeKey">
                    <a-tab-pane key="1" tab="Product Details">Content of Tab Pane 1</a-tab-pane>
                    <a-tab-pane key="2" tab="Special Conditions">Content of Tab Pane 2</a-tab-pane>
                    <a-tab-pane key="3" tab="Warehouse">Content of Tab Pane 3</a-tab-pane>
                    <a-tab-pane key="4" tab="Sale Performance">Content of Tab Pane 3</a-tab-pane>
                    <a-tab-pane key="5" tab="Shift Information">Content of Tab Pane 3</a-tab-pane>
                </a-tabs>
            </div> -->

                <div class="container">
                    <div class="image-text-container">
                        <div class="image-container">
                            <img v-if="showImage" class="img_size" :src="images[0]" alt="Product Image" />
                            <img v-if="!showImage" class="img_size" src="../../assets/img/no_image.png" />
                        </div>
                        <div class="text-container">
                            <div style="font-size: 15px; font-weight: 900;">
                                {{ items.brandName }}
                            </div>
                            <div>
                                <span style="color: #9197B3; line-height: 25px;">Product ID</span>
                                <span style="color: #000000;margin-left: 10px;"> {{ items.id }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="tabs-container">
                        <a-tabs type="card" v-model="activeKey">
                            <a-tab-pane key="1" tab="Product Details">
                                <table class="response-table">
                                    <thead>
                                        <tr>
                                            <th style="color: #9197B3; border: none;">Product Group</th>
                                            <th style="color: #9197B3; border: none;">Category</th>
                                            <th style="color: #9197B3; border: none;">ID/SKU</th>
                                            <th style="color: #9197B3; border: none;">Manufacturer</th>
                                            <th style="color: #9197B3; border: none;">Distributor</th>
                                            <th style="color: #9197B3; border: none;">Type of Vaccine</th>
                                            <th style="color: #9197B3; border: none;">Diseases Prevented</th>
                                            <th style="color: #9197B3; border: none;">Method of Administration</th>
                                            <!-- Add more headers as needed -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ items.groupName }}</td>
                                            <td>{{ items.categoryName }}</td>
                                            <td>{{ items.sku }}</td>
                                            <td>{{ items.manufacturerName }}</td>
                                            <td>{{ items.supplierName }}</td>
                                            <td>N/A</td>
                                            <td>N/A</td>
                                            <td>N/A</td>
                                            <!-- Add more row items as needed -->
                                        </tr>
                                        <!-- Add more rows as needed -->
                                    </tbody>
                                </table>
                            </a-tab-pane>
                            <a-tab-pane key="2" tab="Special Conditions">
                                <table class="response-table">
                                    <thead>
                                        <tr>
                                            <th style="color: #9197B3; border: none; min-width: 200px;">Storage
                                                Conditions</th>
                                            <th style="color: #9197B3; border: none; min-width: 200px;">Dosage</th>
                                            <th style="color: #9197B3; border: none; min-width: 200px;">Mode of
                                                Administration</th>
                                            <th style="color: #9197B3; border: none; min-width: 200px;">Frequency</th>
                                            <!-- Add more headers as needed -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="color: #000000;">+2°C to +8°C</td>
                                            <td style="color: #000000;">One dose per vial</td>
                                            <td style="color: #000000;">Injection</td>
                                            <td style="color: #000000;">
                                                Chickens should be vaccinated with CEVAC® FP L between 4 and 16 weeks of
                                                age.
                                                Birds should be vaccinated no later than 4 weeks before the onset of the
                                                laying.
                                                Re-vaccination is not required following proper initial vaccination.
                                            </td>

                                            <!-- Add more row items as needed -->
                                        </tr>
                                        <!-- Add more rows as needed -->
                                    </tbody>
                                </table>
                            </a-tab-pane>
                            <a-tab-pane key="3" tab="Batches">
                                <a-table :columns="batchColumns" :data-source="batchData" :pagination="pagination"
                                    :loading='tableLoading' :scroll="{ x: 1500, y: 600 }"
                                    @change="handleBatchTableChange" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleBatchReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>


                                    <SettingIcon slot="filterIcon" slot-scope="" />

                                    <template slot="status" slot-scope="data">
                                        <status-component :status="data.status"></status-component>
                                    </template>

                                    <template slot="qualityControl" slot-scope="data">
                                        <status-component :status="data.qualityControl"></status-component>
                                    </template>
                                </a-table>
                            </a-tab-pane>
                            <a-tab-pane key="4" tab="Sale Orders">
                                <a-table :columns="saleColumns" :data-source="saleData" :pagination="pagination"
                                    :loading='tableLoading' :scroll="{ x: 1500, y: 600 }"
                                    @change="handleBatchTableChange" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleBatchReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>


                                    <SettingIcon slot="filterIcon" slot-scope="" />

                                    <template slot="status" slot-scope="data">
                                        <status-component :status="data.status"></status-component>
                                    </template>

                                    <template slot="qualityControl" slot-scope="data">
                                        <status-component :status="data.qualityControl"></status-component>
                                    </template>
                                </a-table>
                            </a-tab-pane>
                            <a-tab-pane key="5" tab="Invoice">
                                <a-table :columns="invoiceColumns" :data-source="invoiceData" :pagination="pagination"
                                    :loading='tableLoading' :scroll="{ x: 1500, y: 600 }"
                                    @change="handleBatchTableChange" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleBatchReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>


                                    <SettingIcon slot="filterIcon" slot-scope="" />

                                    <template slot="paymentStatus" slot-scope="data">
                                        <status-component :status="data.paymentStatus"></status-component>
                                    </template>
                                </a-table>
                            </a-tab-pane>
                            <a-tab-pane key="6" tab="Packages">
                                <a-table :columns="packageColumns" :data-source="packageData" :pagination="pagination"
                                    :loading='tableLoading' :scroll="{ x: 1500, y: 600 }"
                                    @change="handleBatchTableChange" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleBatchSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleBatchReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>


                                    <SettingIcon slot="filterIcon" slot-scope="" />

                                    <template slot="status" slot-scope="data">
                                        <status-component :status="data.status"></status-component>
                                    </template>
                                </a-table>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>
            </div>
        </div>
    </a-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SettingIcon from '../common/components/SettingIcon.vue'
import StatusComponent from '../shared-components/StatusComponent.vue'

const batchColumns = [
    //   {
    //     title: 'Thumb',
    //     // width: 80,
    //     key: 'thumb',
    //     scopedSlots: { customRender: 'thumb' },
    //   },
    {
        title: 'Batch No.',
        dataIndex: 'id',
        width: 150,
    },
    {
        title: 'Product Name',
        dataIndex: 'productName',
        key: 'productName',
        width: 250,
    },
    {
        title: 'Manufacture Date',
        dataIndex: 'manuDate',
        key: 'manuDate',
        width: 150,
    },
    {
        title: 'Expiry Date',
        dataIndex: 'expDate',
        key: 'expDate',
        width: 150,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        width: 150,
    },

    {
        title: 'Manufacturer',
        width: 250,
        dataIndex: 'manufacturer',
    },

    {
        title: 'Status',
        key: 'status',
        width: 250,
        scopedSlots: { customRender: 'status' },
        //width: 110,
    },
    {
        title: 'Received Date',
        dataIndex: 'receivedDate',
        key: 'receivedDate',
        width: 150,
    },
    {
        title: 'Shelf Life',
        dataIndex: 'shelfLife',
        key: 'shelfLife',
        width: 150,
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
        },
        // onFilter: (value, record) =>
        // record.productName
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
    },
    {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        width: 150,
    },
    {
        title: 'Quality Control',
        key: 'qualityControl',
        width: 250,
        scopedSlots: { customRender: 'qualityControl' },
    },


];

const batchData = [
    {
        id: 12345,
        key: 12345,
        productName: "Amino-Vitasol WS (1kg)",
        manuDate: '23-05-2023',
        expDate: '23-05-2023',
        quantity: 56,
        manufacturer: "BioVacc Ltd.",
        status: 'Available',
        receivedDate: "23-05-2023",
        shelfLife: "90 Days",
        location: 'click view',
        qualityControl: 'Passed'
    },
    {
        id: 12265,
        key: 12265,
        productName: "Amino-Vitasol WS (1kg)",
        manuDate: '23-05-2023',
        expDate: '23-05-2023',
        quantity: 70,
        manufacturer: "BioVacc Ltd.",
        status: 'Available',
        receivedDate: "23-05-2023",
        shelfLife: "90 Days",
        location: 'click view',
        qualityControl: 'Passed'
    },
    {
        id: 12115,
        key: 12115,
        productName: "Amino-Vitasol WS (1kg)",
        manuDate: '23-05-2023',
        expDate: '23-05-2023',
        quantity: 10,
        manufacturer: "BioVacc Ltd.",
        status: 'Available',
        receivedDate: "23-05-2023",
        shelfLife: "90 Days",
        location: 'click view',
        qualityControl: 'Passed'
    },
    {
        id: 16645,
        key: 16645,
        productName: "Amino-Vitasol WS (1kg)",
        manuDate: '23-05-2023',
        expDate: '23-05-2023',
        quantity: 22,
        manufacturer: "BioVacc Ltd.",
        status: 'Available',
        receivedDate: "23-05-2023",
        shelfLife: "90 Days",
        location: 'click view',
        qualityControl: 'Passed'
    },
    {
        id: 13345,
        key: 13345,
        productName: "Amino-Vitasol WS (1kg)",
        manuDate: '23-05-2023',
        expDate: '23-05-2023',
        quantity: 88,
        manufacturer: "BioVacc Ltd.",
        status: 'Available',
        receivedDate: "23-05-2023",
        shelfLife: "90 Days",
        location: 'click view',
        qualityControl: 'Passed'
    }
]

const saleColumns = [

    {
        title: 'Order #',
        dataIndex: 'id',
        width: 150,
    },
    {
        title: 'Customer Name',
        dataIndex: 'customerName',
        key: 'customerName',
        width: 200,
    },
    {
        title: 'Purchase Date',
        dataIndex: 'purchaseDate',
        key: 'purchaseDate',
        width: 150,
    },
    {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        width: 250,
    },
    {
        title: 'Total Amount',
        dataIndex: 'amount',
        key: 'amount',
        width: 150,
    },

    {
        title: 'Shipment Date',
        dataIndex: 'shipmentDate',
        key: 'shipmentDate',
        width: 150,
    },

    {
        title: 'Shipment Terms',
        dataIndex: 'shipmentTerms',
        key: 'shipmentTerms',
        width: 250,
    },

    {
        title: 'Status',
        key: 'status',
        width: 250,
        scopedSlots: { customRender: 'status' },
        //width: 110,
    },

];

const saleData = [
    {
        id: 67866,
        key: 67866,
        customerName: "Fuseini Ayambilla",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'New',
        shipmentDate: "16-08-2023",
        shipmentTerms: "Self Pick Up",
    },
    {
        id: 47866,
        key: 47866,
        customerName: "Barima Bama ",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'Processing',
        shipmentDate: "16-08-2023",
        shipmentTerms: "Drop Shipping",
    },
    {
        id: 87866,
        key: 87866,
        customerName: "Fuseini Ayambilla",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'Confirmed',
        shipmentDate: "16-08-2023",
        shipmentTerms: "3rd Party",
    },
    {
        id: 17866,
        key: 17866,
        customerName: "Latifa Yussif",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'Shipped',
        shipmentDate: "16-08-2023",
        shipmentTerms: "Standard Terms",
    },
    {
        id: 27866,
        key: 27866,
        customerName: "Seidu Anass",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'Delivered',
        shipmentDate: "16-08-2023",
        shipmentTerms: "Drop Shipping",
    },
    {
        id: 97866,
        key: 97866,
        customerName: "Fuseini Ayambilla",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'Completed',
        shipmentDate: "16-08-2023",
        shipmentTerms: "3rd Party",
    },
    {
        id: 47800,
        key: 47800,
        customerName: "Fuseini Ayambilla",
        purchaseDate: '16-08-2023',
        location: 'Tribco Central Warehouse',
        amount: '2,000',
        status: 'Delivered',
        shipmentDate: "16-08-2023",
        shipmentTerms: "Self Pick Up",
    },

]

const invoiceColumns = [

    {
        title: 'Invoice #',
        dataIndex: 'id',
        width: 150,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 150,
    },
    {
        title: 'Customer Name',
        dataIndex: 'customerName',
        key: 'customerName',
        width: 200,
    },
    {
        title: 'Due Date',
        dataIndex: 'dueDate',
        key: 'dueDate',
        width: 150,
    },
    {
        title: 'Status',
        key: 'status',
        width: 250,
        dataIndex: 'status',
    },
    {
        title: 'Payment Status',
        key: 'paymentStatus',
        width: 250,
        scopedSlots: { customRender: 'paymentStatus' },
        //width: 110,
    },

    {
        title: 'Payment Terms',
        dataIndex: 'paymentTerms',
        key: 'paymentTerms',
        width: 250,
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
        key: 'balance',
        width: 150,
    },

];

const invoiceData = [
    {
        id: 148900,
        key: 148900,
        date: "14-03-2024",
        customerName: "Ho Veterinary Service",
        dueDate: '17-03-2024',
        status: 'Draft',
        paymentStatus: "Pending",
        paymentTerms: "Cash",
        balance: "2,906",
    },
    {
        id: 148600,
        key: 148600,
        date: "14-03-2024",
        customerName: "Ho Veterinary Service",
        dueDate: '17-03-2024',
        status: 'Due',
        paymentStatus: "Paid",
        paymentTerms: "Cash",
        balance: "2,906",
    },
    {
        id: 148300,
        key: 148300,
        date: "14-03-2024",
        customerName: "Ho Veterinary Service",
        dueDate: '17-03-2024',
        status: 'Disputed',
        paymentStatus: "PartiallyPaid",
        paymentTerms: "Cash",
        balance: "2,906",
    },
]

const packageColumns = [

    {
        title: 'Product Name',
        dataIndex: 'name',
        width: 150,
    },
    {
        title: 'Sales #',
        dataIndex: 'sale',
        key: 'sale',
        width: 150,
    },
    {
        title: 'Quantity Ordered',
        dataIndex: 'quantity',
        key: 'quantity',
        width: 200,
    },
    {
        title: 'Quantity Packed',
        dataIndex: 'date',
        key: 'date',
        width: 150,
    },
    {
        title: 'Order Status',
        key: 'status',
        width: 250,
        scopedSlots: { customRender: 'status' },
    },

];

const packageData = [
    {
        id: 148900,
        key: 148900,
        name: "Amino-Vitasol WS (1kg)",
        sale: 147066,
        quantity: '2,906',
        date: '17-03-2024',
        customerName: "Fuseini Ayambilla",
        dueDate: '17-03-2024',
        status: 'New',
    },
    {
        id: 148910,
        key: 148100,
        name: "Amino-Vitasol WS (1kg)",
        sale: 147066,
        quantity: '2,906',
        date: '17-03-2024',
        customerName: "Barima Bama",
        dueDate: '17-03-2024',
        status: 'Packed',
    },
    {
        id: 148920,
        key: 148200,
        name: "Amino-Vitasol WS (1kg)",
        sale: 147066,
        quantity: '2,906',
        date: '17-03-2024',
        customerName: "Barima Bama",
        dueDate: '17-03-2024',
        status: 'Shipped',
    },
    {
        id: 148930,
        key: 148300,
        name: "Amino-Vitasol WS (1kg)",
        sale: 147066,
        quantity: '2,906',
        date: '17-03-2024',
        customerName: "Barima Bama",
        dueDate: '17-03-2024',
        status: 'Returned',
    },

]




export default {
    name: 'ProductDetails',
    // props: ['items'],
    components: {
        SettingIcon,
        StatusComponent
    },
    data() {
        return {
            brands: [],
            size: 'default',
            items: {},
            loading: false,
            disabled: false,
            showImage: true,
            tableLoading: false,
            activeKey: '1',
            expandIconPosition: 'right',
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            searchText: '',
            searchedColumn: '',
            pagination: {
                pageSize: 20,
                current: 1
            },
            productInventoryDetails: {},
            dotsClass: 'dotClass',
            images: [],
            tabPosition: 'top',
            batchColumns,
            batchData,
            saleColumns,
            saleData,
            invoiceColumns,
            invoiceData,
            packageColumns,
            packageData
        };
    },
    methods: {
        ...mapActions([
            'finalCategoryManufacturerSupplierList',
            'setCatalogInfo',
            'uploadProductImage',
            'getClientProducts',
            'getProductInventory',
            'getAllProductById'
        ]),
        showAddProductModal() {

        },
        // onChange(a, b, c) {
        //     //  console.log(a, b, c);
        // },
        handleClick(event) {
            // If you don't want click extra trigger collapse, you can prevent this:
            event.stopPropagation();
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        showEditProductPage() {
            // console.log("this.items | ", this.items)
            this.setCatalogInfo(this.items);
            this.$router.push('/edit-product').catch(() => { });
        },
        showUploadImage() {
            // console.log("items | ",this.items)
            this.productId = this.items.id
            this.uploadImageVisible = true
        },
        handleUploadImgCancel() {
            this.uploadImageVisible = false
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            // console.log("file type | ", file.type)
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.fileList = [];
                this.showErrorAlert("You can only upload PNG or JPEG file!")
                // console.log("fileList not png | ", this.fileList)
                return false;
            } else {
                // console.log("fileList png | ", this.fileList)
                this.fileList = [...this.fileList, file];
                return false;
            }
        },
        getImageUrls(result) {
            // console.log("result | ",result)
            if (result.imageUrls.length === 0) {
                this.showImage = false
            } else {
                this.showImage = true
                // this.images.push(image2)
                // this.images.push(image3)
                result.imageUrls.forEach(image => {
                    this.images.push(
                        `${process.env.VUE_APP_IMAGE_BASE_URL}/${image.imageUrl}`
                    )
                })
            }
            // console.log("images | ",this.images)
        },
        getProdInventory(productId) {
            // console.log("productId | ", productId)
            this.getProductInventory(productId).then(response => {

                if (response.status === 200) {
                    this.productInventoryDetails = response.data;
                } else {
                    console.log("Error | ", response)
                }
            })
        },
        handleBatchTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination before change | ", this.pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            // console.log("pagination after change | ", this.pagination);
            this.setPaginationInfo(this.pagination)
            this.tableLoading = false
        },
        handleBatchSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            // this.params.page = -1
            // this.params.perPage = -1
            // this.params.searchBy = {
            //     brandName : selectedKeys[0]
            // }
            // this.getProductsBySearSort(this.params)
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleBatchReset(clearFilters) {
            clearFilters();
            this.searchText = '';
            // this.params.searchBy = {
            //     brandName : ''
            // }
            // this.getProducts()
        },


    },
    computed: {
        ...mapGetters(['getCatalog']),
        displayProductDetails() {
            // console.log("newProductform | ", this.newProductform)
            return this.items
        },
        displayFrequency() {
            let frequency = ""
            if (this.productInventoryDetails.prestockFrequency === 0) {
                frequency = "Weekly";
            } else if (this.productInventoryDetails.prestockFrequency === 1) {
                frequency = "Monthly";
            } else if (this.productInventoryDetails.prestockFrequency === 2) {
                frequency = "Quarterly";
            } else {
                frequency = "N/A";
            }

            return frequency
        }

    },
    created() {
        // console.log("getCatalog | ", this.getCatalog)
        if (this.getCatalog) {

            this.getAllProductById(this.getCatalog.id).then(response => {

                // console.log("fileList | ", this.fileList)
                if (response.status === 200) {
                    this.items = response.data
                    this.getImageUrls(response.data);
                } else {
                    // console.log("Error | ", response)
                }
            })
        }
        if (this.getProdInventory) {
            this.getProdInventory(this.getCatalog?.id);
        }
    }
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.img_size {
    width: 108px;
    height: 89px;
    border-radius: 19px;
    margin: 0 auto;
}

.ant-carousel>>>.slick-slide {
    height: 100%;
}

.ant-carousel>>>.slick-active {
    height: 100%;
}

.ant-carousel>>>.slick-current {
    height: 100%;
}

.dotClass {
    color: red;
}

.ant-carousel>>>.slick-dots li button {
    background: #2b8e4e !important;
}

.ant-carousel>>>.slick-slide {
    text-align: center;
    /* height: 160px; */
    line-height: 160px;
    background: #fff;
    overflow: hidden;
}

.ant-carousel>>>.slick-dots {
    position: absolute;
    display: block;
    width: 100%;
    height: -0px;
    margin: 0;
    padding: 0;
    text-align: center;
    list-style: none;
}

.ant-carousel>>>.slick-dots-bottom {
    bottom: 30px;
}

.ant-carousel>>>.slick-slide h3 {
    color: #418a49;
}

.rightSideinputText {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.descInputText {
    /* height: 50px; */
    width: 336px;
    border-radius: 5px;
}

.dropdownItem {
    width: 100%;
    border-radius: 5px;
}

.selecInput {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
    color: #98c14b;
    font-size: 48px;
}

/* .dropdownItem >>> .ant-select-selection__placeholder, 
.ant-select-search__field__placeholder {
    line-height: 29px;
}
.dropdownItem >>> .ant-select-selection--single {
    position: relative;
    height: 45px;
    cursor: pointer;
}
.dropdownItem >>> .ant-select-selection-selected-value {
    line-height: 46px;
} */
.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.container {
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.image-text-container {
    display: flex;
    margin-bottom: 20px;
}

.image-container {
    margin-right: 20px;
}

.text-container {
    margin-top: 15px;
}

.tabs-container {
    width: 100%;
}


.response-table {
    border-collapse: collapse;
    width: 100%;
}

.response-table th,
.response-table td {
    padding: 8px;
    text-align: left;
}

.response-table th {
    /* color: #000000;  */
}

.response-table tbody tr:nth-child(even) {
    background-color: #f2f2f2;
    /* Alternate row background color */
}

.response-table tbody tr td {
    margin-top: 10px;
    border-top: 1px solid #E9EFF4;
    /* Border between rows */
    border-bottom: 1px solid #E9EFF4;
    /* Border between rows */
    border-left: none;
    /* Remove left border */
    border-right: none;
    /* Remove right border */
}

.response-table tbody tr:first-child td {
    border-top-left-radius: 10px;
    /* Rounded top left corner */
    border-top-right-radius: 10px;
    /* Rounded top right corner */
}

.response-table tbody tr:last-child td {
    border-bottom-left-radius: 10px;
    /* Rounded bottom left corner */
    border-bottom-right-radius: 10px;
    /* Rounded bottom right corner */
}

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.actionLinks {
    color: #777777;
}

.rightSideinputText {
    width: 100%;
    height: 50px;
    border-radius: 5px;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
    width: 100%
}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
    color: #9197B3;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
    color: #fff;
}


.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}
</style>
